


















import { Component, Vue, Watch } from "vue-property-decorator"
import Button from "@/components/inputs/Button.vue"
import LayoutLoadable from "@/components/layouts/LayoutLoadable.vue"
import { TemplateSubmission } from "@/model/interfaces/submission/templateSubmission/templateSubmission"
import TemplateSubmissionModule from "@/store/modules/submission/TemplateSubmissionModule"
import TextHeader from "@/components/elements/text/TextHeader.vue"
import { TranslateResult } from "vue-i18n"
import SecurityModule from "@/store/modules/SecurityModule"
import Combobox from "@/components/inputs/Combobox.vue"

@Component({
  components: {
    Combobox,
    Button,
    LayoutLoadable,
    TextHeader
  }
})
export default class ReportDataPublicationViewPdf extends Vue {
  get isFocalPoint(): boolean {
    return SecurityModule.isFocalPoint
  }

  get viewSelected(): string {
    return TemplateSubmissionModule.canViewSelected
  }

  @Watch("viewSelected")
  async onViewSelected(): Promise<void> {
    await this.retrieveCanContent()
  }

  get submission(): TemplateSubmission | null {
    return TemplateSubmissionModule.currentSubmission
  }

  get pdfContent(): string | null {
    return TemplateSubmissionModule.currentSubmissionCanContent
  }

  get loading(): boolean {
    return TemplateSubmissionModule.currentSubmissionCanLoading
  }

  @Watch("submission", { immediate: true })
  async retrieveCanContent(): Promise<void> {
    if (this.submission) {
      await TemplateSubmissionModule.retrieveCanContent()
    }
  }

  async generatePDFExport(): Promise<void> {
    if (this.pdfContent) {
      window.open(this.pdfContent, "_blank")
    }
  }

  public t(tKey: string): TranslateResult {
    return this.$t("templatesubmission.templateview." + tKey)
  }
}
